import { createFileRoute } from "@tanstack/react-router";
import { fetchSettings } from "@/lib/api";

export const Route = createFileRoute("/privacy-policy")({
  loader: async ({ context: { queryClient } }) => {
    return await queryClient.ensureQueryData({
      queryKey: ["settings"],
      queryFn: fetchSettings,
    });
  },
  head: ({ loaderData }) => {
    const settings = loaderData as any;
    const siteName = settings?.site_name || "Lihar Aksara";
    const canonicalUrl = "https://liharaksara.web.id/privacy-policy";
    return {
      meta: [
        { title: `Privacy Policy — ${siteName}` },
        { name: "description", content: `Kebijakan Privasi ${siteName}. Pelajari bagaimana kami menjaga dan menggunakan data Anda.` },
        { property: "og:title", content: `Privacy Policy — ${siteName}` },
        { property: "og:url", content: canonicalUrl },
      ],
      links: [{ rel: "canonical", href: canonicalUrl }],
    };
  },
  component: PrivacyPolicyPage,
});

function PrivacyPolicyPage() {
  return (
    <div className="container-prose py-16 md:py-24">
      <h1 className="font-serif text-4xl md:text-5xl font-medium mb-8">Privacy Policy</h1>
      <div className="prose prose-slate max-w-none font-serif text-lg leading-relaxed text-slate-700 dark:text-slate-300">
        <h2><strong>Kebijakan Privasi</strong></h2>
        <p>Terakhir diperbarui: 23 Mei 2026</p>
        <p>Selamat datang di <a href="https://liharaksara.web.id">Lihar Aksara</a>.</p>
        <p>Privasi pengunjung merupakan hal yang penting bagi kami. Halaman ini menjelaskan bagaimana informasi digunakan selama Anda mengakses website ini.</p>
        
        <h3>Informasi yang Dikumpulkan</h3>
        <p>Website ini dapat mengumpulkan beberapa informasi non-pribadi seperti:</p>
        <ul>
          <li>alamat IP,</li>
          <li>jenis browser,</li>
          <li>perangkat yang digunakan,</li>
          <li>halaman yang dikunjungi,</li>
          <li>waktu akses,</li>
          <li>dan data statistik pengunjung lainnya.</li>
        </ul>
        <p>Informasi tersebut digunakan untuk:</p>
        <ul>
          <li>meningkatkan kualitas website,</li>
          <li>memahami aktivitas pengunjung,</li>
          <li>dan pengembangan layanan.</li>
        </ul>

        <h3><strong>Cookie</strong></h3>
        <p>Website ini dapat menggunakan cookie untuk meningkatkan pengalaman pengguna dan kebutuhan analisis statistik.</p>
        <p>Pengguna dapat menonaktifkan cookie melalui pengaturan browser masing-masing.</p>

        <h3><strong>Tautan Eksternal</strong></h3>
        <p>Website ini dapat berisi tautan menuju situs pihak ketiga. Kami tidak bertanggung jawab atas isi maupun kebijakan privasi dari situs eksternal tersebut.</p>

        <h3><strong>Keamanan Data</strong></h3>
        <p>Kami berusaha menjaga keamanan informasi pengguna, namun tidak dapat menjamin keamanan data sepenuhnya karena internet bukan media yang sepenuhnya aman.</p>

        <h3>Persetujuan</h3>
        <p>Dengan menggunakan website ini, Anda dianggap telah memahami dan menyetujui kebijakan privasi ini.</p>

        <h3><strong>Perubahan Kebijakan</strong></h3>
        <p>Kebijakan privasi dapat diperbarui sewaktu-waktu tanpa pemberitahuan sebelumnya.</p>

        <h3><strong>Kontak</strong></h3>
        <p>Jika memiliki pertanyaan terkait kebijakan privasi ini, silakan hubungi melalui halaman kontak di website.</p>
      </div>
    </div>
  );
}
